import Modal from 'react-bootstrap/Modal';

function ImageModal({ show, onHide, imgSrc }) {
  return (
    <Modal
      centered
      show={show}
      size="lg"
      scrollable={true}
      dialogClassName="modal"
      onHide={onHide}
    >
      <Modal.Header closeButton>full_artwork.jpg</Modal.Header>
      <Modal.Body>
        <img src={imgSrc} style={{ width: '100%' }} alt="" />
      </Modal.Body>
    </Modal>
  );
}

export default ImageModal;
